module.exports = "../images/fishing-lodge-3-15.jpg?v=1501367";